import { render, staticRenderFns } from "./AgendaConfigDialog.vue?vue&type=template&id=12561749&scoped=true"
import script from "./AgendaConfigDialog.vue?vue&type=script&lang=js"
export * from "./AgendaConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./AgendaConfigDialog.vue?vue&type=style&index=0&id=12561749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12561749",
  null
  
)

export default component.exports